import React, { useEffect, useState } from 'react'
import nbrApi from '../../../services/nbrApi'
import ResourceDemandModelChart from '../../components/Charts/ResourceDemandModelChart'

function ResourceDemandIndex() {
  const [data, setData] = useState([])
  const [hkrm_id, setHkrmId] = useState(1)
  const [activeTab, setActiveTab] = useState('CheckOutCheckIn')
  const selectedLoginData = localStorage?.getItem('selectedLoginData')
    ? JSON.parse(localStorage?.getItem('selectedLoginData'))
    : {}
  let properties_id = selectedLoginData?.properties_id
    ? Number(selectedLoginData?.properties_id)
    : null
  const dropdownArray = [...Array(20)]

  // get data
  const getData = async () => {
    let payload = {
      properties_id: properties_id,
      hkrm_id: hkrm_id ? Number(hkrm_id) : null,
    }

    if (hkrm_id && properties_id) {
      const resp = await nbrApi.post('/getresourcemodeldetails', payload)
      if (resp?.data) {
        setData(resp?.data)
      } else {
        setData([])
      }
    }
  }

  // init
  useEffect(() => {
    getData()
  }, [hkrm_id])

  const filterData = (tab) => {
    // switch (tab) {
    //   case 'CheckOutCheckIn':
    //     return data.filter(d => d.checkouts > 0 || d.checkins > 0);
    //   case 'DirtyClean':
    //     return data.filter(d => d.vacant_dirty_rooms > 0 || d.clean_rooms > 0 || d.cleaned_rooms > 0);
    //   case 'Resources':
    //     return data.filter(d => d.resources_required > 0 || d.scheduled_resources > 0);
    //   default:
    //     return data;
    // }
    return data
  }

  // render
  return (
    <div className="row">
      <div className="col-xxl-12">
        <div className="card">
          <div className="card-header">
            <h4 className="heading me-2">Resource Demand Model</h4>
            <div className="text-end">
              <select
                value={hkrm_id}
                className="form-select"
                style={{ minWidth: 200 }}
                onChange={(e) => setHkrmId(e?.target?.value)}
              >
                <option value={null} disabled>
                  Select
                </option>
                {dropdownArray?.map((e, i) => (
                  <option key={i} value={i + 1}>
                    Value {i + 1}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="card-body">
            {data?.length === 0 && (
              <p className="alert alert-primary fw-bold">No Data available!</p>
            )}

            {data?.length > 0 && (
              <>
                {/* Tab Header */}
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === 'CheckOutCheckIn' ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab('CheckOutCheckIn')}
                      href="#!"
                    >
                      Check out / Check in
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === 'DirtyClean' ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab('DirtyClean')}
                      href="#!"
                    >
                      Dirty / Clean
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === 'Resources' ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab('Resources')}
                      href="#!"
                    >
                      Resources
                    </a>
                  </li>
                  {/* <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeTab === 'CheckInOut' ? 'active' : ''
                      }`}
                      onClick={() => setActiveTab('CheckInOut')}
                      href="#!"
                    >
                      Cumulitive Overview
                    </a>
                  </li> */}
                </ul>
                {/* Tab Content */}
                <div className="tab-content pt-4">
                  <div
                    className={`tab-pane ${
                      activeTab === 'CheckOutCheckIn' ? 'active' : ''
                    }`}
                  >
                    <ResourceDemandModelChart
                      data={filterData('CheckOutCheckIn')}
                      type={'CheckOutCheckIn'}
                    />
                    <ResourceDemandModelChart
                      data={filterData('CheckInOut')}
                      type={'CheckInOut'}
                    />
                  </div>
                  <div
                    className={`tab-pane ${
                      activeTab === 'DirtyClean' ? 'active' : ''
                    }`}
                  >
                    <ResourceDemandModelChart
                      data={filterData('DirtyClean')}
                      type={'DirtyClean'}
                    />
                  </div>
                  <div
                    className={`tab-pane ${
                      activeTab === 'Resources' ? 'active' : ''
                    }`}
                  >
                    <ResourceDemandModelChart
                      data={filterData('Resources')}
                      type={'Resources'}
                    />
                  </div>
                  {/* <div
                    className={`tab-pane ${
                      activeTab === 'CheckInOut' ? 'active' : ''
                    }`}
                  >
                    <ResourceDemandModelChart
                      data={filterData('CheckInOut')}
                      type={'CheckInOut'}
                    />
                  </div> */}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ResourceDemandIndex
